import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=51238fe8&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51238fe8",
  null
  
)

export default component.exports